import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastSuccess = message => {
  if (i18n.exists(`backendSuccess.${message}`)) {
    toast.success(i18n.t(`backendSuccess.${message}`), {
      toastId: message,
    });
  } else {
    toast.success(message, {
      toastId: message,
    });
  }
};

export default toastSuccess;